<template>
  <v-btn dark depressed block class="dashboard-button" @click="goTo()" :style="{ 'background-image': 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' + image + ')'}">
    <v-icon top>{{ icon }}</v-icon>
    <br>
    <span class="dashboard-button-title">{{ title }}</span>
  </v-btn>
</template>

<script>
import router from '@/router'
export default {
  props: {
    title: String,
    url: String,
    icon: String,
    image: String,
  },
  methods: {
    goTo () {
      if (this.url.startsWith('http')) {
        window.open(this.url, '_blank')
      } else {
        router.push({ path: this.url })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .dashboard-button {
    background-size: cover;
    background-position: center center;
    &.v-btn {
      height: 135px !important;
    }

    .v-icon {
      position: absolute;
      top: 0px;
    }

    .dashboard-button-title {
      display: block;
      padding-top: 40px;
      white-space: normal;
      font-size: 20px;
      word-break: break-word;
      overflow: hidden;
      max-height: 85px;
      letter-spacing: inherit;
    }
  }
  ::v-deep {
    .v-btn__content {
      max-width: 100%;
    }
  }
</style>
